export const CONTENT_CLASS = 'the-table__cell-content';
